/**
 * Everest's summit glyph, in the shared 120×120 LINE asset box.
 *
 * The peak is Everest's hero motif the way the blossom is Sakura's, and it is
 * drawn in TWO places — the Home tab button (line-menu-button) and the passcode
 * dots (line-passcode). Those two carried their own copies of the path data and
 * promptly drifted, so the geometry lives here and both import it.
 *
 * TWIN-RIDGED: a tall main peak with a lower shoulder to its right, each under
 * its own snowcap. (A single-apex variant was tried on 2026-08-12 and dropped —
 * owner: the lone peak reads flat, the shoulder is what makes it a mountain.)
 */

/** The summit silhouette, sitting on a flat base with clear space beneath it. */
export const PEAK_BODY = 'M14,96 L46,34 Q49,29 52,34 L66,60 L74,48 Q77,43.5 80,48 L106,96 Z';

/** The main peak's snowcap, cut by a jagged snow line. */
export const PEAK_CAP = 'M35,56 L46,34 Q49,29 52,34 L62,53 L57,49 L53,55 L48,47 L43,57 L39,52 Z';

/** The shoulder peak's own small cap. */
export const PEAK_CAP_SMALL = 'M69,56 L74,48 Q77,43.5 80,48 L85,57 L81,53 L77,58 L73,52 Z';
